import React from 'react';
import ReactApexChart from 'react-apexcharts'

const NoDataChart = ({title, subtitle = ''}) => {
    
    const options = {
        chart: {
            height: 350,
            type: 'bar',
        },
        dataLabels: {
            enabled: false
        },
        series: [],
        title: {
            text: title,
        },
        subtitle: {
            text: subtitle
        },
        noData: {
          text: 'NO DATA TO SHOW'
        }
    };

    return (
        <div id="chart">
            <ReactApexChart options={options} series={[]} type="radialBar" height={300} />
        </div>
    )
    
}

export default NoDataChart;